import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"

import translationEl from "./locales/el/translation.json"
import translationEn from "./locales/en/translation.json"
import translationFr from "./locales/fr/translation.json"
import translationDe from "./locales/de/translation.json"

i18n
  .use(LanguageDetector)
  .init({
    debug: false,
    fallbackLng: "el",
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    returnNull: false,
    resources: {
      el: {
        translations: translationEl,
      },
      en: {
        translations: translationEn,
      },
      fr: {
        translations: translationFr,
      },
      de: {
        translations: translationDe,
      }
    },
    detection: {
      order: ["path", "cookie"],
      caches: ["cookie"],
      cookieMinutes: 7 * 24 * 60 * 60 * 1000,
    },
    react: { useSuspense: false },
    ns: ["translations"],
    defaultNS: "translations",
  });

export default i18n